
import styles from './swiperChangeLayout.module.css';
// import Swiper core and required modules
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectCreative,
} from 'swiper';

import DOMPurify from 'dompurify';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-creative';
import 'swiper/css/autoplay';

const SwiperChangeLayout = ({
  subtitle,
  title,
  body,
  content = [],
  style,
}) => {
  const pagination = {
    clickable: true,
    // renderBullet: function (index, className) {
    //   return '<div class="' + className + '">' + (index + 1) + "</div>";
    // },
    renderBullet: function (index, className) {
      return `<div class="${className}">Tab${index}</div>`;
    },
  };
  return (
    <div className={styles.swiperCtn}>
      <div className={styles.ctn} style={style}>

          <h1
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(title),
            }}
          ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(body),
          }}
        ></h5>
        <Swiper
          modules={[Navigation, Pagination, A11y]}
          grabCursor={true}
          pagination={{
            clickable: true,
          }}
          loop={true}
          slidesPerView={1}
          speed={600}
          // onSlideChange={() => console.log("slide change")}
          // onSwiper={(swiper) => console.log(swiper)}
          className={styles.swiperBox}
          spaceBetween={24}
          navigation={{
            nextEl: '.swiper-next',
            prevEl: '.swiper-pre',
          }}
          breakpoints={{
            // when window width is >= 320px
            0: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            // when window width is >= 480px
            414: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            // when window width is >= 640px
            1024: {
              slidesPerView: 1,
              spaceBetween: 48,
            },
          }}
        >
          {content.map(({src,mediaType = "img",text,poster}) => {
            return (
              <SwiperSlide>
                <div className={styles.mediaBox}>
                  {mediaType === 'img' ? (
                    <img alt="SMOOTH 5S" src={src} />
                  ) : (
                    <video
                      autoPlay
                      loop
                      playsInline
                      muted
                      preload
                      src={src}
                      poster={poster}
                    />
                  )}
                </div>

                <div
                  className={styles.swiperItemText}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(text),
                  }}
                ></div>
              </SwiperSlide>
            );
          })}
          <div className="swiper-pre">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5947 32L3.99988 20M3.99988 20L16.5947 8M3.99988 20L36.0001 20"
                stroke="currentColor"
                stroke-width="2"
              />
            </svg>
          </div>

          <div className="swiper-next">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5947 32L3.99988 20M3.99988 20L16.5947 8M3.99988 20L36.0001 20"
                stroke="currentColor"
                stroke-width="2"
              />
            </svg>
          </div>
        </Swiper>
        <div></div>
      </div>
    </div>
  );
};

export default SwiperChangeLayout;
